'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-929adab5.js');
var React = require('react');
var styled = require('styled-components');
var components_SvgIcon_index = require('../SvgIcon/index.js');
var exclamationMark = require('../../exclamation-mark-8535f548.js');
var close = require('../../close-684728c7.js');
var constants_properties = require('../../constants/properties.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var Container = styled__default["default"].div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 8px 21.18px 8px 21.18px;\n"], ["\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 8px 21.18px 8px 21.18px;\n"])), function (_a) {
    var variant = _a.variant, theme = _a.theme;
    switch (variant) {
        case constants_properties.BannerVariant.STANDARD:
            return theme.colors.background.secondary;
        case constants_properties.BannerVariant.INFO:
            return theme.colors.background.information;
        case constants_properties.BannerVariant.WARNING:
            return theme.colors.background.warning;
        case constants_properties.BannerVariant.ERROR:
            return theme.colors.background.negative;
        default:
            return theme.colors.background.secondary;
    }
});
var ExclamationIcon = styled__default["default"](components_SvgIcon_index["default"]).attrs({
    icon: exclamationMark.SvgExclamationMark,
    size: constants_properties.SvgIconSize.MEDIUM,
})(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  margin-right: 10px;\n"], ["\n  margin-right: 10px;\n"])));
var CloseIcon = styled__default["default"](components_SvgIcon_index["default"]).attrs({
    icon: close.SvgClose,
    size: constants_properties.SvgIconSize.MEDIUM,
})(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject([""], [""])));
var CloseIconButton = styled__default["default"].button.attrs({
    'aria-label': 'close-banner',
})(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  all: unset;\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-start;\n  margin-left: auto;\n"], ["\n  all: unset;\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-start;\n  margin-left: auto;\n"])));
var MainContent = styled__default["default"].div(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-left: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  margin-left: ", ";\n"])), function (_a) {
    var isOnClosePresent = _a.isOnClosePresent;
    return (isOnClosePresent ? 'auto' : null);
});
var Banner = function (_a) {
    var content = _a.content, _b = _a.variant, variant = _b === void 0 ? constants_properties.BannerVariant.STANDARD : _b, onClose = _a.onClose;
    return (React__namespace.createElement(Container, { variant: variant },
        React__namespace.createElement(MainContent, { isOnClosePresent: Boolean(onClose) },
            React__namespace.createElement(ExclamationIcon, null),
            content),
        onClose && (React__namespace.createElement(CloseIconButton, { onClick: onClose },
            React__namespace.createElement(CloseIcon, null)))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

exports["default"] = Banner;
